module.exports = __webpack_public_path__ + "static/img/lj-pub-logo.b1fbeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileimg/lj-pub-logo.png
// module id = vQOd
// module chunks = 20